// extracted by mini-css-extract-plugin
export var image = "GraphicDesign-module--image--2z5PR";
export var graphicWrapper = "GraphicDesign-module--graphicWrapper--2-7-3";
export var order1 = "GraphicDesign-module--order1--1hVQ7";
export var order2 = "GraphicDesign-module--order2--GeDtl";
export var spinAround = "GraphicDesign-module--spinAround--3zAIt";